import React from 'react';
import propTypes from './propTypes';

const AboutApplications = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.4073 5.77816C11.1922 5.27305 11.1983 4.06746 10.4211 3.08541C9.64384 2.10336 8.37753 1.71673 7.59269 2.22184C6.80785 2.72695 6.80168 3.93254 7.57892 4.91459C8.35616 5.89664 9.62247 6.28327 10.4073 5.77816Z" fill="currentColor" />
    <path d="M12.7338 13.3526C13.284 12.539 12.9539 11.2738 11.9963 10.5268C11.0388 9.77974 9.81647 9.83375 9.26622 10.6474C8.71597 11.461 9.04614 12.7262 10.0037 13.4732C10.9612 14.2203 12.1835 14.1662 12.7338 13.3526Z" fill="currentColor" />
    <path d="M15.5789 7.08541C14.8017 8.06746 14.8078 9.27305 15.5927 9.77816C16.3775 10.2833 17.6438 9.89664 18.4211 8.91459C19.1983 7.93254 19.1922 6.72695 18.4073 6.22184C17.6225 5.71673 16.3562 6.10336 15.5789 7.08541Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M3 13C1.89543 13 1 13.8954 1 15V23H23V15C23 13.8954 22.1046 13 21 13H18.7808C17.8547 13 17.1448 13.614 16.8179 14.2904C16.3693 15.2189 15.1396 17 12 17C8.86039 17 7.63068 15.2189 7.18208 14.2904C6.85523 13.614 6.14526 13 5.21922 13H3ZM3 21V15H5.21925C5.21925 15 5.22277 15 5.22997 15.0024C5.23796 15.0051 5.25184 15.0112 5.26998 15.0241C5.30878 15.0515 5.35156 15.0991 5.38128 15.1606C6.04685 16.538 7.85681 19 12 19C16.1432 19 17.9531 16.538 18.6187 15.1606C18.6484 15.0991 18.6912 15.0515 18.73 15.0241C18.7482 15.0112 18.762 15.0051 18.77 15.0024C18.7772 15 18.7808 15 18.7808 15H21V21H3Z" fill="currentColor" />
  </svg>
);

AboutApplications.propTypes = propTypes;

export default AboutApplications;
